import Plyr from "plyr";

export default class VideoController {
    constructor() {
        this.videos = document.querySelectorAll(".js-video");
    }

    init() {
        if (this.videos.length > 0) {
            this.videos.forEach((video) => {
                const player = new Plyr(video, {
                    controls: ["play", "progress", "current-time", "pip"],
                });
            });
        }
    }
}
